import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { successToast, errorToast } from "../../../Utils/toast";
import { WhereHouseList } from "../../../redux/services/WhereHouseService/wherehouse.Services";
import Swal from "sweetalert2";

import { ActiveProductList } from "../../../redux/services/ProductService/product.Services";
import { createInventryTransfer } from "../../../redux/services/InventryTransferService/inventory.Services"
function UpdateInventorytransfere() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    fromwarehouseName: "",
    towarehouseName: "",
    product: "",
    quentity: "",
    transferDate: "",
    remark: "",
  });
  useEffect(() => {
    fetchWarehouse();
    fetchProduct();
  }, []);

  const fetchWarehouse = async () => {
    try {
      const res = await WhereHouseList({
        page: 1,
        search: "",
        status: "",
      });

      if (res.success) {
        setWarehouseList(res?.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchProduct = async () => {
    try {
      const res = await ActiveProductList();

      if (res?.success) {
        setProductList(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "fromwherehouseName" && { towarehouseName: "" }),
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  // const validateForm = () => {
  //   const newErrors = {};

  //   if (!formData.fromwarehouseName) {
  //     newErrors.fromwarehouseName = ["Please select From Warehouse"];
  //   }

  //   if (!formData.towarehouseName) {
  //     newErrors.towarehouseName = ["Please select To Warehouse"];
  //   }

  //   if (
  //     formData.fromwarehouseName &&
  //     formData.fromwarehouseName === formData.towarehouseName
  //   ) {
  //     newErrors.towarehouseName = [
  //       "From and To Warehouse cannot be same",
  //     ];
  //   }

  //   if (!formData.product) {
  //     newErrors.product = ["Please select Product"];
  //   }

  //   if (!formData.quentity) {
  //     newErrors.quentity = ["Please enter quantity"];
  //   } else if (Number(formData.quentity) <= 0) {
  //     newErrors.quentity = ["Quantity must be greater than zero"];
  //   }

  //   if (!formData.transferDate) {
  //     newErrors.transferDate = ["Please select transfer date"];
  //   }

  //   setErrors(newErrors);

  //   return newErrors;
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // const validationErrors = validateForm();
    // if (Object.keys(validationErrors).length > 0) {
    //   setTimeout(() => {
    //     const firstErrorField = document.querySelector(".is-invalid");
    //     if (firstErrorField) {
    //       firstErrorField.focus();
    //       firstErrorField.scrollIntoView({
    //         behavior: "smooth",
    //         block: "center",
    //       });
    //     }
    //   }, 100);
    //   return;
    // }

    setLoading(true);
    try {
      const payload = {
        from_warehouse_id: formData.fromwarehouseName,
        to_warehouse_id: formData.towarehouseName,
        product_id: formData.product,
        quantity: formData.quentity,
        transfer_date: formData.transferDate,
        remark: formData.remark,
      };
      const res = await UpdateInventorytransfere(payload);
      if (res?.success) {
        successToast(res?.message);
        setFormData({
          fromwarehouseName: "",
          towarehouseName: "",
          quentity: "",
          product: "",
        });
        setErrors({});

        dispatch(refreshProductList());
        dispatch(closeProductModal());
      } else {
        // Show error toast with message from API
        errorToast(res?.message || "Failed to create warehouse");
      }
    } catch (error) {
      console.error("Error creating warehouse:", error);
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
        errorToast("Please check the form for errors");
      } else {
        errorToast(error?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Edit Inventory Data</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Edit Transfer Inventory</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate("/transfer-inventroy-list")}>
            Back
          </button>
        </div>
      </div>
      <div className="main_page">
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-md-6">
            <label>From Warehouse <span className="text-danger">*</span></label>
            <select
              name="fromwarehouseName"
              value={formData.fromwarehouseName}
              onChange={handleChange}
              className={`form-control custumform ${errors?.fromwarehouseName ? "is-invalid" : ""}`}
            >
              <option value="">Select Warehouse</option>
              {warehouseList?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item?.warehouse_name}
                </option>
              ))}
            </select>
            {errors?.fromwarehouseName && (
              <div className="invalid-feedback d-block">
                {errors.fromwarehouseName[0]}
              </div>
            )}
          </div>
          <div className="col-md-6">
            <label>To wherehouse <span className="text-danger">*</span></label>
            <select
              name="towarehouseName"
              value={formData.towarehouseName}
              onChange={handleChange}
              disabled={!formData.fromwarehouseName}
              className={`form-control custumform ${errors?.towarehouseName ? "is-invalid" : ""
                }`}
            >
              <option value="">
                {formData.fromwarehouseName
                  ? "Select To Warehouse"
                  : "Please select From Warehouse first"}
              </option>

              {warehouseList
                ?.filter(
                  (item) => item.id != formData.fromwarehouseName
                )
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.warehouse_name}
                  </option>
                ))}
            </select>
            {errors?.towarehouseName && (
              <div className="invalid-feedback d-block">
                {errors.towarehouseName[0]}
              </div>
            )}
          </div>

          {/* Manager Name */}
          <div className="col-md-6">
            <label>Please Select Product <span className="text-danger">*</span></label>
            <select
              name="product"
              value={formData.product}
              onChange={handleChange}
              className={`form-control custumform ${errors?.product ? "is-invalid" : ""
                }`}
            >
              <option value="">Select Product</option>

              {productList?.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.product_name}
                </option>
              ))}
            </select>
            {errors?.product && (
              <div className="invalid-feedback d-block">
                {errors.product}
              </div>
            )}
          </div>

          {/* Contact Number */}
          <div className="col-md-6">
            <label>Quentity <span className="text-danger">*</span></label>
            <input
              type="text"
              name="quentity"
              value={formData.quentity}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setFormData((prev) => ({
                  ...prev,
                  quentity: value,
                }));
                if (errors.quentity) {
                  setErrors((prev) => ({
                    ...prev,
                    quentity: null,
                  }));
                }
              }}
              className={`form-control custumform ${errors?.quentity ? "is-invalid" : ""}`}
              placeholder="Enter Quentity"
              maxLength={10}
            />
            {errors?.quentity && (
              <div className="invalid-feedback d-block">
                {errors.quentity[0]}
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label>
              Transfer Date
              <span className="text-danger">*</span>
            </label>

            <input
              type="date"
              name="transferDate"
              value={formData.transferDate}
              onChange={handleChange}
              className={`form-control custumform ${errors?.transferDate ? "is-invalid" : ""
                }`}
            />

            {errors?.transferDate && (
              <div className="invalid-feedback d-block">
                {errors.transferDate[0]}
              </div>
            )}
          </div>
          <div className="col-md-12">
            <label>Remark</label>

            <textarea
              rows="3"
              name="remark"
              value={formData.remark}
              onChange={handleChange}
              className="form-control custumform"
              placeholder="Enter Remark"
            />
          </div>


          {/* SUBMIT */}
          <div className="col-12 text-end">
            <button
              type="submit"
              className="add-btn"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Inventory"}
            </button>
          </div>
        </form>
      </div>
    </div>

  );
}

export default UpdateInventorytransfere;